// Table of contents:
// 1 header
// 2 orderInformation
// 3 orderConfirmation
// 4 positions
// 5 attachment
//  5.1 documents
//  5.2 additionalDocuments
// 6 editOrderItem
// 7 infoOrderItem
// 8 rejectOrderItem
// 9 acceptOrderItem
// 10 rejectOrder
// 11 acceptOrder
import { OrderResponse } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createOrderResponse = (): OrderResponse => {
  return {
    // 1 header
    header: {
      enabled: true,
      title: getTranslationsForConfig('orderResponse.header.title'), // t('orderResponse.header.title')
      // buyer
      buyerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.header.buyerInformation.title',
        ), // t('orderResponse.header.buyerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.externalId',
          ), // t('orderResponse.header.buyerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.company',
          ), // t('orderResponse.header.buyerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.department',
          ), // t('orderResponse.header.buyerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.name',
          ), // t('orderResponse.header.buyerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.phone',
          ), // t('orderResponse.header.buyerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.email',
          ), // t('orderResponse.header.buyerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.address',
          ), // t('orderResponse.header.buyerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.countryCode',
          ), // t('orderResponse.header.buyerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.buyerInformation.labels.vatNumber',
          ), // t('orderResponse.header.buyerInformation.labels.vatNumber')
        },
      },
      // seller
      sellerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.header.sellerInformation.title',
        ), // t('orderResponse.header.sellerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.externalId',
          ), // t('orderResponse.header.sellerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.company',
          ), // t('orderResponse.header.sellerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.department',
          ), // t('orderResponse.header.sellerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.name',
          ), // t('orderResponse.header.sellerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.phone',
          ), // t('orderResponse.header.sellerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.email',
          ), // t('orderResponse.header.sellerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.address',
          ), // t('orderResponse.header.sellerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.countryCode',
          ), // t('orderResponse.header.sellerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.sellerInformation.labels.vatNumber',
          ), // t('orderResponse.header.sellerInformation.labels.vatNumber')
        },
      },
      // billing
      billingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.header.billingInformation.title',
        ), // t('orderResponse.header.billingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.externalId',
          ), // t('orderResponse.header.billingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.company',
          ), // t('orderResponse.header.billingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.department',
          ), // t('orderResponse.header.billingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.name',
          ), // t('orderResponse.header.billingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.phone',
          ), // t('orderResponse.header.billingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.email',
          ), // t('orderResponse.header.billingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.address',
          ), // t('orderResponse.header.billingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.countryCode',
          ), // t('orderResponse.header.billingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.billingInformation.labels.vatNumber',
          ), // t('orderResponse.header.billingInformation.labels.vatNumber')
        },
      },
      // shipping
      shippingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.header.shippingInformation.title',
        ), // t('orderResponse.header.shippingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.externalId',
          ), // t('orderResponse.header.shippingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.company',
          ), // t('orderResponse.header.shippingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.department',
          ), // t('orderResponse.header.shippingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.name',
          ), // t('orderResponse.header.shippingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.phone',
          ), // t('orderResponse.header.shippingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.email',
          ), // t('orderResponse.header.shippingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.address',
          ), // t('orderResponse.header.shippingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.countryCode',
          ), // t('orderResponse.header.shippingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: false,
          label: getTranslationsForConfig(
            'orderResponse.header.shippingInformation.labels.vatNumber',
          ), // t('orderResponse.header.shippingInformation.labels.vatNumber')
        },
      },
    },
    // 2 orderInformation
    orderInformation: {
      enabled: true,
      title: getTranslationsForConfig('orderResponse.orderInformation.title'), // t('orderResponse.orderInformation.title')
      orderId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.orderId.label',
        ), // t('orderResponse.orderInformation.form.orderId.label')
      },
      orderDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.orderDate.label',
        ), // t('orderResponse.orderInformation.form.orderDate.label')
      },
      orderDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.orderDeliveryDate.label',
        ), // t('orderResponse.orderInformation.form.orderDeliveryDate.label')
      },
      termsOfDelivery: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.termsOfDelivery.label',
        ), // t('orderResponse.orderInformation.form.termsOfDelivery.label')
      },
      currency: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.currency.label',
        ), // t('orderResponse.orderInformation.form.currency.label')
      },
      totalNetItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.totalNetItemAmount.label',
        ), // t('orderResponse.orderInformation.form.totalNetItemAmount.label')
      },
      notes: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderInformation.form.notes.label',
        ), // t('orderResponse.orderInformation.form.notes.label')
      },
      allowanceCharges: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.orderInformation.allowanceCharges.title',
        ), // t('orderResponse.orderInformation.allowanceCharges.title'),

        table: {
          enabled: true,
          columns: [
            {
              dataType: 'string',
              enabled: true,
              field: 'Description.Text',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'orderResponse.orderInformation.allowanceCharges.table.columns.descriptionText.filterPlaceholder',
              ), // t('orderResponse.orderInformation.allowanceCharges.table.columns.descriptionText.filterPlaceholder')
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.allowanceCharges.table.columns.descriptionText.header',
              ), // t('orderResponse.orderInformation.allowanceCharges.table.columns.descriptionText.header')
              sortable: true,
            },
            {
              dataType: 'alcType',
              enabled: true,
              field: 'AlcType',
              filter: true,
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.allowanceCharges.table.columns.alcType.header',
              ), // t('orderResponse.orderInformation.allowanceCharges.table.columns.alcType.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'percent',
              enabled: true,
              field: 'Percentage',
              filter: true,
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.allowanceCharges.table.columns.percentage.header',
              ), // t('orderResponse.orderInformation.allowanceCharges.table.columns.percentage.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'price',
              enabled: true,
              field: 'Amount',
              filter: true,
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.allowanceCharges.table.columns.amount.header',
              ), // t('orderResponse.orderInformation.allowanceCharges.table.columns.amount.header')
              sortable: true,
            },
            {
              dataType: 'status',
              enabled: true,
              field: 'Status',
              filter: true,
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.allowanceCharges.table.columns.status.header',
              ), // t('orderResponse.orderInformation.allowanceCharges.table.columns.status.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'orderResponse.orderInformation.allowanceCharges.table.emptyMessageDetails',
          ), // t('orderResponse.orderInformation.allowanceCharges.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'orderResponse.orderInformation.allowanceCharges.table.emptyMessageTitle',
          ), // t('orderResponse.orderInformation.allowanceCharges.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Payload.OrderDate',
          sortOrder: 1,
        },
      },
      termsOfPayment: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.orderInformation.termsOfPayment.title',
        ), // t('orderResponse.orderInformation.termsOfPayment.title'),

        table: {
          enabled: true,
          columns: [
            {
              align: 'right',
              dataType: 'day',
              enabled: true,
              field: 'Days',
              filterPlaceholder: getTranslationsForConfig(
                'orderResponse.orderInformation.termsOfPayment.table.columns.days.filterPlaceholder',
              ), // t('orderResponse.orderInformation.termsOfPayment.table.columns.days.filterPlaceholder')
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.termsOfPayment.table.columns.days.header',
              ), // t('orderResponse.orderInformation.termsOfPayment.table.columns.days.header')

              width: '200px',
            },
            {
              align: 'right',
              dataType: 'percent',
              enabled: true,
              field: 'Percent',
              header: getTranslationsForConfig(
                'orderResponse.orderInformation.termsOfPayment.table.columns.percent.header',
              ), // t('orderResponse.orderInformation.termsOfPayment.table.columns.percent.header')

              width: '200px',
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'orderResponse.orderInformation.termsOfPayment.table.emptyMessageDetails',
          ), // t('orderResponse.orderInformation.termsOfPayment.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'orderResponse.orderInformation.termsOfPayment.table.emptyMessageTitle',
          ), // t('orderResponse.orderInformation.termsOfPayment.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Payload.OrderDate',
          sortOrder: 1,
        },
      },
    },
    // 3 orderConfirmation
    orderConfirmation: {
      enabled: true,
      title: getTranslationsForConfig('orderResponse.orderConfirmation.title'), // t('orderResponse.orderConfirmation.title')
      responsePeriod: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.responsePeriod.label',
        ), // t('orderResponse.orderConfirmation.form.responsePeriod.label')
      },
      confirmationId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.confirmationId.label',
        ), // t('orderResponse.orderConfirmation.form.confirmationId.label')
        placeholder: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.confirmationId.placeholder',
        ), // t('orderResponse.orderConfirmation.form.confirmationId.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^.{1,20}$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.orderConfirmation.form.confirmationId.validation.regexErrorMessage',
          ), // t('orderResponse.orderConfirmation.form.confirmationId.validation.regexErrorMessage')
        },
      },
      response: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.response.label',
        ), // t('orderResponse.orderConfirmation.form.response.label')
      },
      department: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.department.label',
        ), // t('orderResponse.orderConfirmation.form.department.label')
        readonly: false,
      },
      name: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.name.label',
        ), // t('orderResponse.orderConfirmation.form.name.label')
        readonly: false,
      },
      phone: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.phone.label',
        ), // t('orderResponse.orderConfirmation.form.phone.label')
        readonly: false,
        validation: {
          regex: '^[0-9+() -]*$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.orderConfirmation.form.phone.validation.regexErrorMessage',
          ), // t('orderResponse.orderConfirmation.form.phone.validation.regexErrorMessage')
        },
      },
      email: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.email.label',
        ), // t('orderResponse.orderConfirmation.form.email.label')
        readonly: false,
        validation: {
          regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.orderConfirmation.form.email.validation.regexErrorMessage',
          ), // t('orderResponse.orderConfirmation.form.email.validation.regexErrorMessage')
        },
      },
      remarks: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.orderConfirmation.form.remarks.label',
        ), // t('orderResponse.orderConfirmation.form.remarks.label')
        readonly: false,
      },
    },
    // 4 positions
    positions: {
      enabled: true,
      title: getTranslationsForConfig('orderResponse.positions.title'), // t('orderResponse.positions.title')
      table: {
        enabled: true,
        title: getTranslationsForConfig('orderResponse.positions.table.title'), // t('orderResponse.positions.table.title'),
        columns: [
          {
            dataType: 'string',
            field: 'OrderPosition',
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.orderPosition.header',
            ), // t('orderResponse.positions.table.columns.orderPosition.header')
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationSellerProductId.filterPlaceholder',
            ), // t('orderResponse.positions.table.columns.confirmationSellerProductId.filterPlaceholder')
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationSellerProductId.header',
            ), // t('orderResponse.positions.table.columns.confirmationSellerProductId.header')
            sortable: true,
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductDescription',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationSellerProductDescription.filterPlaceholder',
            ), // t('orderResponse.positions.table.columns.confirmationSellerProductDescription.filterPlaceholder')
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationSellerProductDescription.header',
            ), // t('orderResponse.positions.table.columns.confirmationSellerProductDescription.header')
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationPrice',
            filter: true,
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationPrice.header',
            ), // t('orderResponse.positions.table.columns.confirmationPrice.header')
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationQuantity',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationQuantity.filterPlaceholder',
            ), // t('orderResponse.positions.table.columns.confirmationQuantity.filterPlaceholder')
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationQuantity.header',
            ), // t('orderResponse.positions.table.columns.confirmationQuantity.header')
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationPriceSum',
            filter: true,
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationPriceSum.header',
            ), // t('orderResponse.positions.table.columns.confirmationPriceSum.header')
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'date',
            field: 'ConfirmationDeliveryDate',
            filter: true,
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationDeliveryDate.header',
            ), // t('orderResponse.positions.table.columns.confirmationDeliveryDate.header')
            sortable: true,
          },
          {
            align: 'center',
            dataType: 'boolean',
            field: 'HasAllowanceChargeSum',
            filter: true,
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.hasAllowanceChargeSum.header',
            ), // t('orderResponse.positions.table.columns.hasAllowanceChargeSum.header')
            sortable: true,
          },
          {
            dataType: 'status',
            field: 'ConfirmationCode',
            filter: true,
            header: getTranslationsForConfig(
              'orderResponse.positions.table.columns.confirmationCode.header',
            ), // t('orderResponse.positions.table.columns.confirmationCode.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orderResponse.positions.table.emptyMessageDetails',
        ), // t('orderResponse.positions.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'orderResponse.positions.table.emptyMessageTitle',
        ), // t('orderResponse.positions.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 5 attachment
    attachment: {
      enabled: true,
      title: getTranslationsForConfig('orderResponse.attachment.title'), // t('orderResponse.attachment.title')
      // 5.1 documents
      documents: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.attachment.documents.title',
        ), // t('orderResponse.attachment.documents.title'),
        columns: [
          {
            dataType: 'string',
            enabled: true,
            field: 'Name',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orderResponse.attachment.documents.table.columns.name.filterPlaceholder',
            ), // t('orderResponse.attachment.documents.table.columns.name.filterPlaceholder')
            header: getTranslationsForConfig(
              'orderResponse.attachment.documents.table.columns.name.header',
            ), // t('orderResponse.attachment.documents.table.columns.name.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orderResponse.attachment.documents.table.emptyMessageDetails',
        ), // t('orderResponse.attachment.documents.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'orderResponse.attachment.documents.table.emptyMessageTitle',
        ), // t('orderResponse.attachment.documents.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Name',
        sortOrder: 1,
      },
      // 5.2 additionalDocuments
      additionalDocuments: {
        enabled: true,
        title: getTranslationsForConfig(
          'orderResponse.attachment.additionalDocuments.title',
        ), // t('orderResponse.attachment.additionalDocuments.title'),
        columns: [
          {
            dataType: 'string',
            enabled: true,
            field: 'Name',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orderResponse.attachment.additionalDocuments.table.columns.name.filterPlaceholder',
            ), // t('orderResponse.attachment.additionalDocuments.table.columns.name.filterPlaceholder')
            header: getTranslationsForConfig(
              'orderResponse.attachment.additionalDocuments.table.columns.name.header',
            ), // t('orderResponse.attachment.additionalDocuments.table.columns.name.header')

            width: '400px',
          },
          {
            dataType: 'string',
            enabled: true,
            field: 'Category',

            header: getTranslationsForConfig(
              'orderResponse.attachment.additionalDocuments.table.columns.category.header',
            ), // t('orderResponse.attachment.additionalDocuments.table.columns.category.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orderResponse.attachment.additionalDocuments.table.emptyMessageDetails',
        ), // t('orderResponse.attachment.additionalDocuments.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'orderResponse.attachment.additionalDocuments.table.emptyMessageTitle',
        ), // t('orderResponse.attachment.additionalDocuments.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Name',
        sortOrder: 1,
      },
    },
    // 6 editOrderItem
    editOrderItem: {
      enabled: true,
      itemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.itemId.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.itemId.label')
      },
      confirmationItemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationItemId.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationItemId.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      countryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.countryOfOrigin.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.countryOfOrigin.label')
      },
      confirmationCountryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationCountryOfOrigin.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationCountryOfOrigin.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[A-Za-z]{1,9}$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationCountryOfOrigin.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationCountryOfOrigin.validation.regexErrorMessage')
        },
      },
      gtin: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.gtin.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.gtin.label')
      },
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.buyerProductId.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.buyerProductId.label')
      },
      confirmationSellerProductId: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationSellerProductId.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationSellerProductId.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.buyerProductDescription.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.buyerProductDescription.label')
      },

      confirmationSellerProductDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationSellerProductDescription.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationSellerProductDescription.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },

      orderQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderQuantity.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderQuantity.label')
      },
      confirmationQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationQuantity.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationQuantity.label')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationQuantity.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationQuantity.validation.regexErrorMessage')
        },
      },
      orderUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderUnit.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderUnit.label')
      },
      confirmationUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationUnit.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationUnit.label')
        readonly: true,
        validation: {
          isRequired: false,
        },
      },
      orderPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderPriceBaseQuantity.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderPriceBaseQuantity.label')
      },
      confirmationPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationPriceBaseQuantity.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPriceBaseQuantity.label')
        readonly: true,
        validation: {
          isRequired: false,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationPriceBaseQuantity.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPriceBaseQuantity.validation.regexErrorMessage')
        },
      },
      orderPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderPriceUnitOfMeasure.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderPriceUnitOfMeasure.label')
      },
      confirmationPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.label')
        readonly: true,
        validation: {
          isRequired: false,
          regex: '^.{0,3}$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.validation.regexErrorMessage')
        },
      },
      orderPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderPrice.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderPrice.label')
      },
      confirmationPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationPrice.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPrice.label')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationPrice.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPrice.validation.regexErrorMessage')
        },
      },
      orderPriceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderPriceSum.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderPriceSum.label')
      },
      confirmationPriceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationPriceSum.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPriceSum.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationPriceSum.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationPriceSum.validation.regexErrorMessage')
        },
      },
      allowanceChargeSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.allowanceChargeSum.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.allowanceChargeSum.label')
      },
      confirmationAllowanceChargeSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'orderResponse.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.validation.regexErrorMessage',
          ), // t('orderResponse.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.validation.regexErrorMessage')
        },
      },
      lineItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.lineItemAmount.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.lineItemAmount.label')
      },
      confirmationLineItemAmount: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationLineItemAmount.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationLineItemAmount.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      orderDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.orderDeliveryDate.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.orderDeliveryDate.label')
      },
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.edit.dialog.form.confirmationDeliveryDate.label',
        ), // t('orderResponse.positions.table.edit.dialog.form.confirmationDeliveryDate.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 7 infoOrderItem
    infoOrderItem: {
      enabled: true,
      itemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.itemId.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.itemId.label')
      },
      confirmationItemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationItemId.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationItemId.label')
      },

      countryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.countryOfOrigin.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.countryOfOrigin.label')
      },
      confirmationCountryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationCountryOfOrigin.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationCountryOfOrigin.label')
      },

      gtin: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.gtin.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.gtin.label')
      },

      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.buyerProductId.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.buyerProductId.label')
      },
      confirmationSellerProductId: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationSellerProductId.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationSellerProductId.label')
      },

      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.buyerProductDescription.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.buyerProductDescription.label')
      },
      confirmationSellerProductDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationSellerProductDescription.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationSellerProductDescription.label')
      },

      orderQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderQuantity.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderQuantity.label')
      },
      confirmationQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationQuantity.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationQuantity.label')
      },

      orderUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderUnit.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderUnit.label')
      },
      confirmationUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationUnit.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationUnit.label')
      },

      orderPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderPriceBaseQuantity.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderPriceBaseQuantity.label')
      },
      confirmationPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationPriceBaseQuantity.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationPriceBaseQuantity.label')
      },

      orderPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderPriceUnitOfMeasure.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderPriceUnitOfMeasure.label')
      },
      confirmationPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationPriceUnitOfMeasure.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationPriceUnitOfMeasure.label')
      },

      orderPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderPrice.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderPrice.label')
      },
      confirmationPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationPrice.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationPrice.label')
      },

      orderPriceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderPriceSum.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderPriceSum.label')
      },
      confirmationPriceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationPriceSum.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationPriceSum.label')
      },

      allowanceChargeSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.allowanceChargeSum.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.allowanceChargeSum.label')
      },
      confirmationAllowanceChargeSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationAllowanceChargeSum.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationAllowanceChargeSum.label')
      },

      lineItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.lineItemAmount.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.lineItemAmount.label')
      },
      confirmationLineItemAmount: {
        enabled: false,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationLineItemAmount.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationLineItemAmount.label')
      },

      orderDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.orderDeliveryDate.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.orderDeliveryDate.label')
      },
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationDeliveryDate.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationDeliveryDate.label')
      },

      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationReasonCode.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationReasonCode.label')
        options: [
          {
            name: getTranslationsForConfig(
              'orderResponse.positions.table.info.dialog.general.form.confirmationReasonCode.options.notInStock',
            ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationReasonCode.options.notInStock')
            code: 'notInStock',
          },
        ],
      },
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.confirmationReasonDescription.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.confirmationReasonDescription.label')
      },

      notes: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.info.dialog.general.form.notes.label',
        ), // t('orderResponse.positions.table.info.dialog.general.form.notes.label')
      },

      allowanceCharges: {
        enabled: true,
        table: {
          enabled: true,
          columns: [
            {
              dataType: 'string',
              enabled: true,
              field: 'Description.Text',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.descriptionText.filterPlaceholder',
              ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.descriptionText.filterPlaceholder')
              header: getTranslationsForConfig(
                'orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.descriptionText.header',
              ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.descriptionText.header')
              sortable: true,
            },
            {
              dataType: 'alcType',
              enabled: true,
              field: 'AlcType',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.alcType.filterPlaceholder',
              ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.alcType.filterPlaceholder')
              header: getTranslationsForConfig(
                'orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.alcType.header',
              ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.alcType.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'percent',
              enabled: true,
              field: 'Percentage',
              filter: true,
              header: getTranslationsForConfig(
                'orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.percentage.header',
              ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.percentage.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'price',
              enabled: true,
              field: 'Amount',
              filter: true,
              header: getTranslationsForConfig(
                'orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.amount.header',
              ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.columns.amount.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'orderResponse.positions.table.info.dialog.allowanceCharges.table.emptyMessageDetails',
          ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'orderResponse.positions.table.info.dialog.allowanceCharges.table.emptyMessageTitle',
          ), // t('orderResponse.positions.table.info.dialog.allowanceCharges.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Payload.OrderDate',
          sortOrder: 1,
        },
      },
    },
    // 8 rejectOrderItem
    rejectOrderItem: {
      enabled: true,
      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.reject.dialog.form.confirmationReasonCode.label',
        ), // t('orderResponse.positions.table.reject.dialog.form.confirmationReasonCode.label')
        options: [
          {
            name: getTranslationsForConfig(
              'orderResponse.positions.table.reject.dialog.form.confirmationReasonCode.options.notInStock',
            ), // t('orderResponse.positions.table.reject.dialog.form.confirmationReasonCode.options.notInStock')
            code: 'notInStock',
          },
        ],
        placeholder: getTranslationsForConfig(
          'orderResponse.positions.table.reject.dialog.form.confirmationReasonCode.placeholder',
        ), // t('orderResponse.positions.table.reject.dialog.form.confirmationReasonCode.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.positions.table.reject.dialog.form.confirmationReasonDescription.label',
        ), // t('orderResponse.positions.table.reject.dialog.form.confirmationReasonDescription.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 9 acceptOrderItem
    acceptOrderResponseItem: {
      enabled: true,
    },
    // 10 rejectOrder
    rejectOrder: {
      enabled: true,
      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.title.reject.dialog.form.confirmationReasonCode.label',
        ), // t('orderResponse.title.reject.dialog.form.confirmationReasonCode.label')
        options: [
          {
            name: getTranslationsForConfig(
              'orderResponse.title.reject.dialog.form.confirmationReasonCode.options.notInStock',
            ), // t('orderResponse.title.reject.dialog.form.confirmationReasonCode.options.notInStock')
            code: 'notInStock',
          },
          {
            name: getTranslationsForConfig(
              'orderResponse.title.reject.dialog.form.confirmationReasonCode.options.unknown',
            ), // t('orderResponse.title.reject.dialog.form.confirmationReasonCode.options.unknown')
            code: 'unknown',
          },
          {
            name: getTranslationsForConfig(
              'orderResponse.title.reject.dialog.form.confirmationReasonCode.options.other',
            ), // t('orderResponse.title.reject.dialog.form.confirmationReasonCode.options.other')
            code: 'other',
          },
        ],
        placeholder: getTranslationsForConfig(
          'orderResponse.title.reject.dialog.form.confirmationReasonCode.placeholder',
        ), // t('orderResponse.title.reject.dialog.form.confirmationReasonCode.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.title.reject.dialog.form.confirmationReasonDescription.label',
        ), // t('orderResponse.title.reject.dialog.form.confirmationReasonDescription.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 11 acceptOrder
    acceptOrder: {
      enabled: true,
      confirmationId: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.title.send.dialog.form.confirmationId.label',
        ), // t('orderResponse.title.send.dialog.form.confirmationId.label')
        readonly: true,
      },
      confirmationDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'orderResponse.title.send.dialog.form.confirmationDate.label',
        ), // t('orderResponse.title.send.dialog.form.confirmationDate.label')
        readonly: true,
      },
      table: {
        enabled: true,
        columns: [
          {
            dataType: 'string',
            field: 'OrderPosition',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.orderPosition.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.orderPosition.header')
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductId',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationSellerProductId.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationSellerProductId.header')
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductDescription',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationSellerProductDescription.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationSellerProductDescription.header')
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationPrice',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationPrice.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationPrice.header')
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationQuantity',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationQuantity.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationQuantity.header')
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationLineItemAmount',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationLineItemAmount.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationLineItemAmount.header')
          },
          {
            align: 'right',
            dataType: 'date',
            enabled: true,
            field: 'ConfirmationDeliveryDate',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationDeliveryDate.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationDeliveryDate.header')
          },
          {
            align: 'center',
            dataType: 'boolean',
            field: 'HasAllowanceChargeSum',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.hasAllowanceChargeSum.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.hasAllowanceChargeSum.header')
          },
          {
            dataType: 'status',
            field: 'ConfirmationCode',
            header: getTranslationsForConfig(
              'orderResponse.title.send.dialog.orderOverview.table.columns.confirmationCode.header',
            ), // t('orderResponse.title.send.dialog.orderOverview.table.columns.confirmationCode.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orderResponse.title.send.dialog.orderOverview.table.emptyMessageDetails',
        ), // t('orderResponse.title.send.dialog.orderOverview.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'orderResponse.title.send.dialog.orderOverview.table.emptyMessageTitle',
        ), // t('orderResponse.title.send.dialog.orderOverview.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
  }
}
